import { module } from 'angular'
import KdDocument from './document'
import KdGrid from './grid'
import KdUi from './ui'
import ngStorage from 'ngstorage'

export default module('kd', [
  KdDocument,
  KdGrid,
  KdUi,
  ngStorage.name,
])



// WEBPACK FOOTER //
// ./src/kendu/module.js